<template>
    <div id="footer">
        ©{{Year}} 版权所有 施耐德电气(中国)有限公司
    </div>
</template>

<script>
let nowDate = new Date();
export default {
    data(){
        return{
            Year: nowDate.getFullYear()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>